// Import Core Components here
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

// Import App depedency here
import { Input } from "arv-reactcomponents";

class EmailInput extends Component {
  constructor() {
    super();
    this.state = {
      emailInputErrorMsg: "",
      isEmailInputValid: false,
      emailErrorClass: "",
      isValid: "",
    };

    this.onBlur = this.onBlur.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
  }

  onBlur() {
    let emailErrorClass = "nwc-hidden";
    let isValid = "";
    if (!this.state.isEmailInputValid) {
      emailErrorClass = "";
      isValid = "is-invalid";
    }
    this.setState({ emailErrorClass, isValid });
  }

  validateEmail(e) {
    this.setState({ emailErrorClass: "nwc-hidden" });
    const validateEmailField = this.validateEmailFieldRef.getValidatedOutput(
      e.target.value,
    );
    this.setState({
      isEmailInputValid: validateEmailField.isValid,
      emailInputErrorMsg: validateEmailField.errorMsg,
      isValid: "",
    });
    this.props.validateEmailInput(validateEmailField);
  }

  render() {
    const { emailInputErrorMsg, isValid } = this.state;
    const {
      className,
      placeholder,
      name,
      text,
      errorMsgClassName,
      ...otherProps
    } = this.props;
    return (
      <Fragment>
        <Input
          className={`${className} ${isValid}`}
          name={name}
          onBlur={this.onBlur}
          onChange={this.validateEmail}
          placeholder={placeholder}
          type="email"
          value={text}
          ref={values => {
            this.validateEmailFieldRef = values;
          }}
          validateWithPattern={[
            {
              pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
              msg: "Enter a valid email address.",
            },
          ]}
          {...otherProps}
        />
        <div
          className={`nw-form-err-msg ${
            this.state.emailErrorClass
          } ${errorMsgClassName}`}
        >
          {emailInputErrorMsg}
        </div>
      </Fragment>
    );
  }
}

EmailInput.defaultProps = {
  className: "",
  errorMsgClassName: "",
};

EmailInput.propTypes = {
  className: PropTypes.string,
  errorMsgClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  validateEmailInput: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: EmailInput,
  component: EmailInput,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/V1/EmailInput/index.js